<template>
    <header class="header header--fixed header--menu-all" v-scroll="fixedScroll">
        <!-- S: head -->
        <!-- <div class="header__head">
            <v-container>
                <div class="w-100 d-flex justify-end align-center">
                    <user-menu />
                    <a href="https://secure.donus.org/withcan/mypage" target="_blank" class="px-16 page-text page-text--sm grey-6--text font-weight-medium line-height-2">후원 마이페이지</a>
                </div>
            </v-container>
        </div> -->
        <!-- E: head -->
        <!-- S: body -->
        <div class="header__body">
            <v-container>
                <h1 class="header__logo">
                    <router-link to="/" title="홈으로 이동"><span class="d-sr-only">위드캔복지재단</span></router-link>
                </h1>
                <div class="header__contents">
                    <div class="header__gnb flex-column flex-xl-row justify-end">
                        <!-- S: Gnb -->
                        <client-gnb className="gnb"></client-gnb>
                        <client-gnb />
                        <!-- E: Gnb -->
                         
                        <!-- S: 후원하기 -->
                        <donation-link />
                        <!-- E: 후원하기 -->

                        <!-- <user-menu class="d-xl-none" /> -->
                    </div>
                </div>
            </v-container>
        </div>
        <!-- E: body -->
        <!-- S: hamburger -->
        <div class="hamburger-btn">
            <span></span>
        </div>
        <!-- E: hamburger -->
        <!-- <div class="header__bg" /> -->
    </header>
</template>

<script>
import ClientGnb from "@/components/client/inc/client-gnb.vue";
import UserMenu from "@/components/client/inc/user-menu.vue";
import DonationLink from "@/components/client/inc/donation-link.vue"

export default {
    components: {
        ClientGnb,
        UserMenu,
        DonationLink,
    },
    data(){
        return {
            window: {
                width: 0,
                height: 0,
            },
        };
    },
    mounted() {
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작

        if(this.isDesktop){
            this.initPcEvent();
        }
        if(this.isMobile){
            this.initMobileEvent();
        }
    },
    methods: {
        fixedScroll: function() {
            var header = document.querySelector('.header');
            var scrollTop = window.scrollY || document.documentElement.scrollTop;

            if(scrollTop > 50){
                header.classList.add('scroll-active');
            }else {
                header.classList.remove('scroll-active');
            }
        },
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // PC
        initPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].addEventListener('mouseenter', gnbLiOver);
                lis[i].addEventListener('mouseleave', gnbLiOut);
            }

            var gnb = document.querySelector('.gnb');
            gnb.addEventListener('mouseenter', gnbOver);
            gnb.addEventListener('mouseleave', gnbOut);
        },
        destroyPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].removeEventListener('mouseenter', gnbLiOver);
                lis[i].removeEventListener('mouseleave', gnbLiOut);
            }

            var gnb = document.querySelector('.gnb');
            gnb.removeEventListener('mouseenter', gnbOver);
            gnb.removeEventListener('mouseleave', gnbOut);
        },
        // Mobile
        initMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector('.hamburger-btn');
            hamburgerBtn.addEventListener('click', mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
            gnbLinkToggle.forEach(function (el) {
                el.addEventListener('click', toggleAccordion);
            });
        },
        destroyMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector('.hamburger-btn');
            hamburgerBtn.removeEventListener('click', mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
            gnbLinkToggle.forEach(function (el) {
                el.removeEventListener('click', toggleAccordion);
            });
        },
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        if(this.isDesktop){
            this.destroyPcEvent();
        }
        if(this.isMobile){
            thid.destroyMobileEvent();
        }
    },
    watch: {
        // 라우트 이동 시 모바일 메뉴 닫기 (같은 페이지로 이동해도 닫히도록)
        $route: function() {
            var header = document.querySelector('.header');
            if(header){
                header.classList.remove('mobile-menu-on');
                header.querySelectorAll('.gnb__link--toggle').forEach(function (el) {
                    el.parentNode.classList.remove('active');
                });
            }
        },
        isDesktop: function() {
            if(this.isDesktop){
                this.initPcEvent();
            }else{
                this.destroyPcEvent();
            }
        },
        isMobile: function() {
            if(this.isMobile){
                this.initMobileEvent();
            }else{
                this.destroyMobileEvent();
            }
        },
    },
};

// PC
function gnbLiOver(){
    var headerBg = document.querySelector('.header__bg');
    var gnbSub = this.querySelector('.gnb__sub');

    this.classList.add('active');
    if (gnbSub == null){
        headerBg.classList.add('none');
    }
};
function gnbLiOut(){
    var headerBg = document.querySelector('.header__bg');
    var gnbSub = this.querySelector('.gnb__sub');

    this.classList.remove('active');
    if (gnbSub == null){
        headerBg.classList.remove('none');
    }
};
function gnbOver(){
    var header = document.querySelector('.header');
    header.classList.add('menu-active');
};
function gnbOut(){
    var header = document.querySelector('.header');
    header.classList.remove('menu-active');
};

// Mobile
function mobileMenuToggle(){
    var HTML = document.querySelector('html');
    var header = document.querySelector('.header');
    var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');

    header.classList.toggle('mobile-menu-on');
    // HTML.classList.toggle('hidden');

    if(header.classList.contains('mobile-menu-on')){
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove('active');
        })
    }
};
function toggleAccordion(el) {
    var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
    var targetLi = el.currentTarget.parentNode.classList;
    var target = el.currentTarget;

    el.preventDefault();
    if (targetLi.contains('active')) {
        targetLi.remove('active');
    }else {
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove('active');
        })
        targetLi.add('active');
    }
};
</script>